import { useLocation } from 'react-router-dom'

import {
  deduplicationKindConfig,
  deduplicationKindFromPath,
  type DeduplicationKind,
} from '../config'

export const useDeduplicationKind = (): DeduplicationKind => {
  const { pathname } = useLocation()
  return deduplicationKindFromPath(pathname)
}

export const useDeduplicationKindConfig = () => {
  const kind = useDeduplicationKind()
  return deduplicationKindConfig[kind]
}
